<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $tc("add") }} {{ $tc("screensizeformat", 1) }}
      </div>
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-5">
          <div>
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  placeholder="."
                  type="text"
                  name="screen_size_format"
                  id="screen_size_format"
                  v-validate="'required'"
                  v-model="ssf_name"
                />
                <label>{{ $tc("screensizeformat", 1) }}</label>
              </div>
              <!-- <Tooltip :title="$t('enterScreenSizeFormat')" /> -->
              <!-- <img
                src="@/assets/img/icons/question.svg"
                height="20"
                width="20"
                class="ml-2"
                v-b-tooltip.hover
                alt=
              /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && ssf_name == ''">
                {{ $tc("pleaseEnterScreenSizeFormatName") }}</span
              >
            </p>
          </div>
        </div>
        <div class="col-lg-6 col-xl-4 align-self-center mb-5">
          <div class="row pb-3">
            <div class="col-md-3 col-xl-2 align-self-center">
              <label class="mb-0">{{ $t("active") }}</label>
            </div>
            <div class="col-md-9 col-xl-10 align-self-center">
              <!-- <label class="ios-switch"> -->
              <b-form-checkbox
                type="checkbox"
                value="Y"
                class="j-checkbox ml-2 mb-0"
                v-model="ssf_is_active"
                switch
              />
              <!-- <span class="switch-slider"></span>
              </label> -->
            </div>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button class="btn-blue" @click.prevent.stop="handleSubmit(true)">
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="handleSubmit(false)"
            type="submit"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="resetHandler" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="screen-size-format"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      btenable: false,
      ssf_name: "",
      ssf_is_active: "Y",
      submitted: false,
    };
  },
  mounted() {
    this.resetHandler();
  },
  methods: {
    resetHandler: function () {
      this.ssf_name = "";
    },
    handleSubmit(flag) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          let payload = {
            ssf_name: this.ssf_name,
            ssf_is_active: this.ssf_is_active,
          };
          MasterService.AddScreenSizeFormat(payload)
            .then((response) => {
              const { data } = response;
              if (data.status) {
                if (flag) {
                  this.$router.push({
                    path: "screen-size-format",
                  });
                } else {
                  this.resetHandler();
                }
              } else {
                this.$toasted.show(data.message);
                console.log("show error1 :", data.message);
              }
            })
            .catch((error) => {
              this.$toasted.show(data.error);
              console.log("show error2 :", error);
            });
        } else {
          console.log("else :");
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ScreenSizeFormat/addScreenSizeFormat.vue